import React, { useRef } from "react";
import { InputText } from "primereact/inputtext";
import { OverlayPanel } from "primereact/overlaypanel";
import { InputNumber } from "primereact/inputnumber";

interface DeadlineHourPickerProps {
  value: number; // total minutes
  onChange: (minutes: number) => void;
  disabled?: boolean;
  className?: string;
  minHours?: number;
  panelStyle?: React.CSSProperties;
  inputWidthClass?: string;
}

export const DeadlineHourPicker: React.FC<DeadlineHourPickerProps> = ({
  value,
  onChange,
  disabled,
  className,
  minHours = 1,
  panelStyle = { width: "18rem" },
  inputWidthClass = "w-4rem",
}) => {
  const op = useRef<OverlayPanel>(null);
  const hours = Math.floor(value / 60);
  const minutes = value % 60;
  const display = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;

  return (
    <>
      <style>{`.deadline-picker-overlay.p-overlaypanel::before,.deadline-picker-overlay.p-overlaypanel::after{display:none!important}`}</style>
      <InputText
        readOnly
        value={display}
        className={className}
        disabled={disabled}
        onClick={(e) => !disabled && op.current?.toggle(e)}
        style={{ cursor: disabled ? undefined : "pointer" }}
      />
      <OverlayPanel
        ref={op}
        style={panelStyle}
        pt={{ root: { className: "deadline-picker-overlay" } }}
      >
        <div className="flex align-items-center justify-content-center gap-1">
          <div className="flex align-items-center gap-1 flex-nowrap">
            <span className="text-500 text-xs" style={{ whiteSpace: "nowrap" }}>Horas</span>
            <InputNumber
              value={hours}
              onValueChange={(e) => {
                const h = Math.min(Math.max(e.value || 0, minHours), 120);
                onChange(h * 60 + minutes);
              }}
              showButtons
              buttonLayout="vertical"
              min={minHours}
              max={120}
              incrementButtonIcon="pi pi-chevron-up"
              decrementButtonIcon="pi pi-chevron-down"
              incrementButtonClassName="p-button-text p-button-plain p-0"
              decrementButtonClassName="p-button-text p-button-plain p-0"
              className={inputWidthClass}
              inputClassName="text-center border-none shadow-none px-1 py-0"
              inputStyle={{ fontSize: "1.25rem" }}
              disabled={disabled}
            />
          </div>
          <span className="font-bold">:</span>
          <div className="flex align-items-center gap-1 flex-nowrap">
            <InputNumber
              value={minutes}
              onValueChange={(e) => {
                const m = Math.min(Math.max(e.value || 0, 0), 55);
                onChange(hours * 60 + m);
              }}
              showButtons
              buttonLayout="vertical"
              min={0}
              max={55}
              step={5}
              incrementButtonIcon="pi pi-chevron-up"
              decrementButtonIcon="pi pi-chevron-down"
              incrementButtonClassName="p-button-text p-button-plain p-0"
              decrementButtonClassName="p-button-text p-button-plain p-0"
              className={inputWidthClass}
              inputClassName="text-center border-none shadow-none px-1 py-0"
              inputStyle={{ fontSize: "1.25rem" }}
              disabled={disabled}
            />
            <span className="text-500 text-xs" style={{ whiteSpace: "nowrap" }}>Minutos</span>
          </div>
        </div>
      </OverlayPanel>
    </>
  );
};
